import { Notification } from '@whitelist/wl-old-library/store/notifications/helpers/types'

export type InternalVars = Record<string, string>

const linkPattern = /\{link:(\w+)\}/g
const replaceLinks = (body: string, v: Notification['vars']): string => {
  const replacementFunction = (match: string, prop: string): string => {
    const link = v[prop]
    if (link === undefined) return match

    return `<a class="link--accent" href="${link.url}" target="${link.target}">${link.text}</a>`
  }
  return body.replaceAll(linkPattern, replacementFunction)
}

const localPattern = /\{local:(\w+)\}/g
const replaceLocals = (body: string, l: InternalVars): string => {
  const replacementFunction = (match: string, prop: string): string => {
    const local = l[prop]
    if (local === undefined) return match

    return local
  }

  return body.replaceAll(localPattern, replacementFunction)
}

export const createNotificationStringParser = (internalVars: InternalVars) => {
  return (body: string, v: Notification['vars']): string => {
    const replacedLinks = replaceLinks(body, v)
    const replacedLocals = replaceLocals(replacedLinks, internalVars)
    return replacedLocals
  }
}
